import React from 'react'
import { Stack, Table, TableBody, Grid, TableCell, TableContainer, TableHead, TableRow, Box, Button, Paper, Tooltip } from '@mui/material'
import moment from 'moment/moment'
import { useSelector } from 'react-redux'
import { getVehicleAndChartDateSummaryColumns } from '../common/reportConstants'

const DispatchMiddSection5 = ({
  tableData,
  loginData,
  reportType,
  showSummaryReport,
  detailedFilter,
  selFromBranch,
  selDestCity,
  selBranch,
  toDate,
  fromDate,
  selVehicle,
  selPaymentTpe,
}) => {
  const companySettings = useSelector((state) => state?.common?.companySettings)
  const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
  const loginCountryId = companySettings[0]?.DefaultCurrencyID;
  const columns = getVehicleAndChartDateSummaryColumns(loginCountryId,UseToPayAsCOD);
  const SecontInsideRowContent = ({ item, index,fontVal }) => {
    return (
      <>
        <TableRow>
          {Object.keys(item).length == 15 ? (
            <>
              <TableCell
                className="reportTD"
                colSpan={4}
                style={{
                  fontWeight: '700',
                  backgroundColor:'#EEE',
                  fontSize: fontVal,
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  color: '#000',
                }}
              >
                {item.ChartDate}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.Quantity}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.paidFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.ToPayCodFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.OnAccountFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.DddvFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.FocFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.SelfFreight.toFixed(2)}
              </TableCell>

              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.totalFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.SummaryAllCartage.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.SummaryAllHamali.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.SummaryAllOther.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.SummaryInsurance.toFixed(2)}
              </TableCell>
              {loginCountryId!==2 &&
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.SummaryServiceTaxAmount.toFixed(2)}
              </TableCell>
              }
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.SummaryNetAmount.toFixed(2)}
              </TableCell>
            </>
          ) : (
            <>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
              >
                {item.VehicleNo}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left',whiteSpace:'pre-line' }}
              >
                {item.UniqueTripNames}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
              >
                {item.UniqueTripIDs}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'leftx',
                  whiteSpace: 'pre',
                  // width:'100px'
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '150px',
                }}
              >
                <Tooltip title={item.UniqueChartDate} placement="top-start">
                      <span>{item.UniqueChartDate}</span>
                    </Tooltip>
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.Quantity}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.paidFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.ToPayCodFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.OnAccountFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.DddvFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.FocFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.SelfFreight.toFixed(2)}
              </TableCell>

              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.totalFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.SummaryAllCartage.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.SummaryAllHamali.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.SummaryAllOther.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.SummaryInsurance.toFixed(2)}
              </TableCell>
              {loginCountryId!==2 &&
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.SummaryServiceTaxAmount.toFixed(2)}
              </TableCell>
              }
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.SummaryNetAmount.toLocaleString('en-IN', { maximumFractionDigits: 2 })}
              </TableCell>
            </>
          )}
        </TableRow>
      </>
    )
  }
  const SecontInsideRowContentForExcel = ({ item, index,fontVal }) => {
    return (
      <>
        <TableRow>
          {Object.keys(item).length == 15 ? (
            <>
              <TableCell
                className="reportTD"
                colSpan={4}
                style={{
                  fontWeight: '700',
                  backgroundColor:'#EEE',
                  fontSize: fontVal,
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  color: '#000',
                }}
              >
                {item.ChartDate}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.Quantity}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.paidFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.ToPayCodFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.OnAccountFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.DddvFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.FocFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.SelfFreight.toFixed(2)}
              </TableCell>

              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.totalFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.SummaryAllCartage.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.SummaryAllHamali.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.SummaryAllOther.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={loginCountryId!==2?1:2}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.SummaryInsurance.toFixed(2)}
              </TableCell>
              {loginCountryId!==2 && <TableCell
                className="reportTD"
                colSpan={1}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.SummaryServiceTaxAmount.toFixed(2)}
              </TableCell>}
              <TableCell
                className="reportTD"
                colSpan={2}
                style={{ backgroundColor:'#EEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
              >
                {item.SummaryNetAmount.toFixed(2)}
              </TableCell>
            </>
          ) : (
            <>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
              >
                {item.VehicleNo}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left',whiteSpace:'pre-line' }}
              >
                {item.UniqueTripNames}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
              >
                {item.UniqueTripIDs}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'leftx',
                  whiteSpace:'pre-line',
                  width:'100px'
                }}
              >
                {item.UniqueChartDate}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.Quantity}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.paidFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.ToPayCodFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.OnAccountFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.DddvFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.FocFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.SelfFreight.toFixed(2)}
              </TableCell>

              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.totalFreight.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.SummaryAllCartage.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.SummaryAllHamali.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.SummaryAllOther.toFixed(2)}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={loginCountryId!==2 ?1:2}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.SummaryInsurance.toFixed(2)}
              </TableCell>
              {loginCountryId!==2 &&
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.SummaryServiceTaxAmount.toFixed(2)}
              </TableCell>
               }
              <TableCell
                className="reportTD"
                colSpan={2}
                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
              >
                {item.SummaryNetAmount.toLocaleString('en-IN', { maximumFractionDigits: 2 })}
              </TableCell>
            </>
          )}
        </TableRow>
      </>
    )
  }
  
  return (
    <>
      <Stack sx={{ marginLeft: 2, marginRight: 2, height: 480, paddingTop: '10px' }}>
        <TableContainer className="scrollBlue" sx={{"&::-webkit-scrollbar": {width:'6px',height:'6px'},border:'1px solid #aeaeae','& .MuiTableCell-root': {
            fontSize: '14px !important'
        }}} component={Paper}>
          <Table  className="table1 table-Report" size="small" aria-label="a dense table">
            <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
              <TableRow >
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '14px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'left',
                    color: '#444444',
                    height:'36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={6}
                >
                  Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '14px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'center',
                    color: '#444444',
                    height:'36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={6}
                >
                  Destination City: {selDestCity?.name}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '14px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'right',
                    color: '#444444',
                    height:'36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={6}
                >
                  Destination Branch: {selBranch?.name}
                </TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                {columns.map((col, index) => (
                  <TableCell
                    key={index}
                    className="ReportItemHead"
                    style={{
                      fontWeight: 'bold',
                      fontSize: '14px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '700',
                      color: '#444444',
                      height: '36px',
                      backgroundColor: '#bfe1ff',
                      textAlign: index === 0 || index === 1 || index === 2 || index === 3 ? 'left' : 'right',
                      whiteSpace: 'pre',
                      verticalAlign: 'top',
                    }}
                    colSpan={1}
                  >
                    {col.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {tableData?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={18}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '12px',
                          lineheight: '16px',
                          letterspacing: '0.24px',
                        }}
                      >
                        <span>No results found. Please refine your search parameters and search again.</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : tableData?.length >= 1 ? (
              <TableBody
                className="filter-data-row"
                style={{
                  textAlign: 'center',
                  fontSize: '12px',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  fontWeight: '500',
                  marginLeft: '5px',
                }}
              >
                {tableData?.map((item, index) => (
                  <SecontInsideRowContent item={item} index={index} key={index} fontVal={'12px'}/>
                ))}
              </TableBody>
            ) : (
              ''
            )}
          </Table>
          <Table style={{display:'none'}} id="tables" className="table1 table-Report" size="small" aria-label="a dense table">
            <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
              <TableRow>
                <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }} colSpan={9}>
                  <h3 style={{ paddingLeft: '17px' }}>Report For: Dispatch Report -</h3>
                </TableCell>
                <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'right' }} colSpan={10}>
                  <h3 style={{ paddingLeft: '17px' }}>Company Name : {loginData.strCompanyName}</h3>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={18}></TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  From Dispatch Date
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    fontWeight: 'bold',
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  To Dispatch Date
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  dispatch By Branch
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  Destination City
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={3}
                >
                  Destination Branch
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Vehicle Number
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Payment Type
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Report Type
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  Report View
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={3}
                >
                  Report Option
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{moment(fromDate).format('MM/DD/YYYY')}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{moment(toDate).format('MM/DD/YYYY')}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{selFromBranch?.name || loginData?.strBranchName}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{selDestCity?.name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                  <span>{selBranch?.name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={1}
                >
                  <span>{selVehicle?.name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={1}
                >
                  <span>{selPaymentTpe?.name || 'All'}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={1}
                >
                  <span>{reportType?.Name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{showSummaryReport?.Name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={3}
                >
                  <span>{detailedFilter?.Name} </span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={18}></TableCell>
              </TableRow>
            </TableHead>
            <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
              <TableRow >
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'left',
                    color: '#444444',
                    height:'36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={6}
                >
                  Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'center',
                    color: '#444444',
                    height:'36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={6}
                >
                  Destination City: {selDestCity?.name}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '20px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '700',
                    textAlign: 'right',
                    color: '#444444',
                    height:'36px',
                    backgroundColor: '#bfe1ff'
                  }}
                  colSpan={7}
                >
                  Destination Branch: {selBranch?.name}
                </TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                {columns.map((col, index) => (
                  <TableCell
                    key={index}
                    className="ReportItemHead"
                    style={{
                      fontWeight: 'bold',
                      fontSize: '20px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '700',
                      color: '#444444',
                      height: '36px',
                      backgroundColor: '#bfe1ff',
                      textAlign: index === 1 || index === 2 || index === 3 || index === 4 ? 'left' : 'right',
                      whiteSpace: 'pre',
                      verticalAlign: 'top',
                    }}
                    colSpan={index === columns.length - 1 ? 2 : 1}
                  >
                    {col.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {tableData?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={18}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '20px',
                          lineheight: '16px',
                          letterspacing: '0.24px',
                        }}
                      >
                        <span>No results found. Please refine your search parameters and search again.</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : tableData?.length >= 1 ? (
              <TableBody
                className="filter-data-row"
                style={{
                  textAlign: 'center',
                  fontSize: '20px',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  fontWeight: '500',
                  marginLeft: '5px',
                }}
              >
                {tableData?.map((item, index) => (
                  <SecontInsideRowContentForExcel item={item} index={index} key={index} fontVal={'20px'}/>
                ))}
              </TableBody>
            ) : (
              ''
            )}
          </Table>
        </TableContainer>
      </Stack>
    </>
  )
}

export default DispatchMiddSection5
